export default __webpack_public_path__ + "static/media/Bloodsire Tasset.23374216.jpg";